import { render, staticRenderFns } from "./AdminTrainingRetailerViewPage.vue?vue&type=template&id=78496c2e&scoped=true"
import script from "./AdminTrainingRetailerViewPage.vue?vue&type=script&lang=js"
export * from "./AdminTrainingRetailerViewPage.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainingRetailerViewPage.vue?vue&type=style&index=0&id=78496c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78496c2e",
  null
  
)

export default component.exports